import { render, staticRenderFns } from "./ContestUpComing.vue?vue&type=template&id=7bf42a69"
import script from "./ContestUpComing.vue?vue&type=script&lang=js"
export * from "./ContestUpComing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports